<div class="background" *ngIf="!isDashboard">
    <app-website-header></app-website-header>
<img src="../../../../assets/images/under_development.png" alt="" class="w-100">
<app-website-footer></app-website-footer>
</div>
<div *ngIf="isDashboard" class="isDashboard">
    <img src="../../../../assets/images/under_development.png" alt="" class="w-100" style="height: 850px;">
</div>